import converter from '../../../utils/converter';
import {SCP_BYTES} from '../scpConsts';

const BYTE_CHARS_COUNT = 2;

const getDataFromFrame = (frame, {offset, size}) => {
    const result = frame.slice(offset * BYTE_CHARS_COUNT, (offset + size) * BYTE_CHARS_COUNT);

    return result;
};

const isRequestAndResponseHeaderEqual = (requestFrame, response) => {
    try {
        const getHeader = (hex) => {
            const frameHeader = hex.substring(6, 10);
            const headerBin = converter.hex2binString(frameHeader).padStart(10, '0').slice(-10);

            return headerBin;
        };
        const requestHeaderBin = getHeader(requestFrame);
        const responseHeaderBin = getHeader(response);
        const isEqualHeader = responseHeaderBin === requestHeaderBin;

        return isEqualHeader;
    } catch (e) {
        return false;
    }
};

const REPORT_ID_LENGTH = 2;

const getReportIdFromFrame = (frame) => {
    const result = frame.slice(0, REPORT_ID_LENGTH);

    return result;
};

const getReportIdDecFromFrame = (frame) => {
    const reportIdHex = getReportIdFromFrame(frame);
    const result = converter.hex2dec(reportIdHex);

    return result;
};

const removeReportIdFromFrame = (frame) => {
    const command = frame.slice(REPORT_ID_LENGTH);

    return command;
};

const doesFrameMatchMask = ({frame, offset, mask}) => {
    const byteToCheck = getDataFromFrame(frame, {offset, size: 1});
    const result = (converter.hex2dec(byteToCheck) & mask) === mask;

    return result;
};

const getFrameNetworkLayerSize = (frame) => {
    const frameDataSizeByte = getDataFromFrame(frame, SCP_BYTES.NETWORK_LAYER_FRAME_SIZE);
    const frameDataSize = converter.hex2dec(frameDataSizeByte);

    return frameDataSize;
};

const removeRubbishFromFrame = (frame) => {
    const frameDataSizeByte = getFrameNetworkLayerSize(frame);
    const result = getDataFromFrame(frame, {offset: 0, size: SCP_BYTES.FRAME_NETWORK_LAYER.offset + frameDataSizeByte});

    return result;
};

export default {
    isRequestAndResponseHeaderEqual,
    getReportIdFromFrame,
    removeReportIdFromFrame,
    getDataFromFrame,
    getReportIdDecFromFrame,
    doesFrameMatchMask,
    removeRubbishFromFrame,
    getFrameNetworkLayerSize,
};
